import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericCheckbox } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { useAppStore } from '../../stores';
import { useMemoizedInput } from '../../hooks';
import { InputIds } from '../../misc';


const CreateProgramInput: InputWithoutSource = ({ input }) => {
    const { nodesStore, settingsStore } = useAppStore();

    const businessIdInput = useMemoizedInput(
        InputIds.GeneralInformation.BusinessId,
        nodesStore.generalInformationNode?.inputs
    );

    React.useEffect(() => {
        const hasBusinessId = businessIdInput?.hasValue ?? false;
        input.setValue(hasBusinessId ? false : settingsStore.settingsHasLayers);
    }, [input, businessIdInput?.hasValue, settingsStore.settingsHasLayers]);

    return <GenericCheckbox label={input.name} input={input} />;
};

CreateProgramInput.meta = {
    inputType: InputModel.name
};

export default observer(CreateProgramInput);
